import {Route, BrowserRouter, Routes,} from "react-router-dom";
import Home from "../Pages/Home";
import Produtos from "../Pages/Produtos";
import Assistencia from "../Pages/Assistencia";
import Comercial from "../Pages/Comercial";
import BalancasCuiaba from "../Pages/BalancasCuiaba";
import PesagemRodoviaria from "../Pages/PesagemRodoviaria";
import ProdBalCC from "../Pages/ProdBalCC";
import ProdBalMM from "../Pages/ProdBalMM";
import ProdBalSD from "../Pages/ProdBalSD";
import ProdBalTMM from "../Pages/ProdBalTMM";
import ScrollToTop from "../Components/ScrollToTop";
import ProdCelBRC3A from "../Pages/ProdCelBRC3A";
import ProdCelBRC3D from "../Pages/ProdCelBRC3D";
import ProdCelPDX from "../Pages/ProdCelPDX";
import ProdCelBSDS from "../Pages/ProdCelBSDS";

const Rotas = () => {
    return(
        
        <BrowserRouter>
            <ScrollToTop/>
            <Routes>
                <Route element = {<Home/>} path="/"/>
                <Route element = {<Produtos/>} path="/produtos"/>
                <Route element = {<Assistencia/>} path="/assistencia-tecnica"/>
                <Route element = {<Comercial/>} path="/comercial"/>
                <Route element = {<BalancasCuiaba/>} path="/balancas-cuiaba"/>
                <Route element = {<PesagemRodoviaria/>} path="/produtos/pesagem-rodoviaria"/>
                <Route element = {<ProdBalCC/>} path="/produtos/pesagem-rodoviaria/balanca-concreto-cc"/>
                <Route element = {<ProdBalSD/>} path="/produtos/pesagem-rodoviaria/balanca-concreto-sd"/>
                <Route element = {<ProdBalMM/>} path="/produtos/pesagem-rodoviaria/balanca-mista-modular-mm"/>
                <Route element = {<ProdBalTMM/>} path="/produtos/pesagem-rodoviaria/balanca-total-metalica-modular-tmm"/>
                <Route element = {<ProdCelBRC3A/>} path="/produtos/pesagem-rodoviaria/celula-brc3a"/>
                <Route element = {<ProdCelBRC3D/>} path="/produtos/pesagem-rodoviaria/celula-brc3d"/>
                <Route element = {<ProdCelPDX/>} path="/produtos/pesagem-rodoviaria/celula-pdx"/>
                <Route element = {<ProdCelBSDS/>} path="/produtos/pesagem-rodoviaria/celula-bsds"/>
            </Routes>
        </BrowserRouter>
        
    )
}

export default Rotas;